var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":_vm._variant,"size":_vm.size,"disabled":_vm.disabled},on:{"click":_vm.click}},[_vm._t("default"),_vm._v(" "+_vm._s(_vm._title))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }